import Model from "./Model";
import IPlaylist from "./interfaces/IPlaylist";

export default class Playlist extends Model implements IPlaylist {
  static type = "playlists";
  code?: string;
  title?: string;
}
